import React from "react";

class Navbar extends React.Component {
    render() {
        return (
            <>
                <nav className='position fixed-top'>
                    <nav
                        className='navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block '
                        id='templatemo_nav_top'>
                        <div className='container text-light'>
                            <div className='w-100 d-flex justify-content-between'>
                                <div>
                                    <i className='fa fa-envelope mx-2'></i>
                                    <a
                                        className='navbar-sm-brand text-light text-decoration-none'
                                        href='mailto:SabZ@gmail.com'>
                                        director@sabzonline.in
                                    </a>
                                    <i className='fa fa-phone mx-2'></i>
                                    <a
                                        className='navbar-sm-brand text-light text-decoration-none'
                                        href='tel:+91 7382200558 '>
                                        +91 7382200558
                                    </a>
                                </div>
                                <div>
                                    <a className='text-light' href='/' target='_blank'>
                                        <i className='fab fa-facebook-f fa-sm fa-fw me-2'></i>
                                    </a>
                                    <a className='text-light' href='/' target='_blank'>
                                        <i className='fab fa-instagram fa-sm fa-fw me-2'></i>
                                    </a>
                                    <a className='text-light' href='/' target='_blank'>
                                        <i className='fab fa-twitter fa-sm fa-fw me-2'></i>
                                    </a>
                                    <a className='text-light' href='/' target='_blank'>
                                        <i className='fab fa-linkedin fa-sm fa-fw'></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </nav>

                    <nav className='navbar navbar-expand-lg navbar-light shadow '>
                        <div className='container d-flex justify-content-between align-items-center '>
                            <a
                                className='navbar-brand text-success logo h1 align-self-center'
                                href='index.html'>
                                SabZ
                            </a>

                            <button
                                className='navbar-toggler border-0'
                                type='button'
                                data-bs-toggle='collapse'
                                data-bs-target='#templatemo_main_nav'
                                aria-controls='navbarSupportedContent'
                                aria-expanded='false'
                                aria-label='Toggle navigation'>
                                <span className='navbar-toggler-icon'></span>
                            </button>

                            <div
                                className='align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between'
                                id='templatemo_main_nav'>
                                <div className='flex-fill'>
                                    <ul className='nav navbar-nav d-flex justify-content-between mx-lg-auto'>
                                        <li className='nav-item'>
                                            <a className='nav-link' href='/'>
                                                Home
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav-link' href='/about'>
                                                About
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav-link' href='#contact'>
                                                Contact
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <div className='dropdown'>
                                                <a
                                                    className='nav-link dropdown'
                                                    href='/shop_static'>
                                                    {' '}
                                                    Shop

                                                </a>

                                            </div>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav-link' href='/'>
                                                Team
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className='navbar align-self-center d-flex'>
                                    <div className='d-lg-none flex-sm-fill mt-3 mb-4 col-7 col-sm-auto pr-3'>
                                        <div className='input-group'>
                                            <input
                                                type='text'
                                                className='form-control'
                                                id='inputMobileSearch'
                                                placeholder='Search ...'
                                            />
                                            <div className='input-group-text'>
                                                <i className='fa fa-fw fa-search'></i>
                                            </div>
                                        </div>
                                    </div>
                                    <a
                                        className='nav-icon d-none d-lg-inline'
                                        href='/'
                                        data-bs-toggle='modal'
                                        data-bs-target='#templatemo_search'>
                                        <i className='fa fa-fw fa-search text-dark mr-2'></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </nav>
                </nav>
            </>
        )
    }
}


export default Navbar